module.exports = __webpack_public_path__ + "img/phone.903815d9.svg";